import { Form } from 'antd';
import TcFormButtons from 'components/UI/FormButtons/TcFormButtons';
import TcForm from 'components/UI/form/TcForm';
import endpointUrls from 'global/Constants/endpointUrls';
import clientModel, { client } from 'global/Models/clientModel';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { convertFormValuesToEnglishNumber } from 'global/default';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useState } from 'react';

interface IOrderCreateClient {
  setClient: (_client: client) => void;
}

const OrderCreateClient: FC<IOrderCreateClient> = ({ setClient }) => {
  //states
  const [loading, setLoading] = useState<boolean>(false);

  //hooks
  const [form] = Form.useForm();

  //functions
  const handleSubmit = async (value: any) => {
    setLoading(true);
    await ApiService.post(endpointUrls.clientCreate, value)
      .then((res: IBackendGetGeneric<client>) => handleApiThenGeneric({ res, notifFail: true, notifSuccess: true, onSuccessData: setClient }))
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };
  const handleChange = async (value: any, values: any) => {
    convertFormValuesToEnglishNumber(value, values, ['telephonNumber', 'mobile'], form, true);
  };

  return (
    <div>
      <TcForm form={form} onFinish={handleSubmit} onValuesChange={handleChange}>
        {clientModel.inputs}
        <TcFormButtons noCancel submitButtonText='ثبت' loading={loading} />
      </TcForm>
    </div>
  );
};

export default OrderCreateClient;
